import { Attr, HasMany, HasOne, Model } from "spraypaint";

import type MediaRequest from "shared/resources/MediaRequest";
import type SourceRestriction from "shared/resources/SourceRestriction";
import { ApplicationRecord } from "shared/services/spraypaint";

import type Location from "./Location";

@Model()
class SourceRecord extends ApplicationRecord {
  static jsonapiType = "source_records";

  @HasOne() location: Location;

  @Attr() logoUrl: string;

  @HasMany() mediaRequests: MediaRequest[];

  @Attr() name: string;

  @HasMany() sourceRestrictions: SourceRestriction[];

  @Attr() timeZone: string;
}

export default SourceRecord;
